import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Box, 
  IconButton,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Header = () => {
  const { t, toggleLanguage, language } = useLanguage();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const isActive = (path) => location.pathname === path;

  return (
    <AppBar position="sticky" elevation={0}>
      <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
        <Typography 
          variant="h6" 
          component={Link} 
          to="/" 
          sx={{ 
            textDecoration: 'none', 
            color: 'inherit',
            fontWeight: 600,
            fontSize: { xs: '1.25rem', md: '1.5rem' }
          }}
        >
          Hannah{' '}
          <Box component="span" sx={{ color: 'primary.main' }}>
            Blau
          </Box>
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2 } }}>
          <Button
            component={Link}
            to="/"
            color="inherit"
            size={isMobile ? 'small' : 'medium'}
            sx={{ 
              fontWeight: isActive('/') ? 600 : 400,
              color: isActive('/') ? 'primary.main' : 'inherit',
              display: { xs: 'none', md: 'inline-flex' }
            }}
          >
            {t('nav.home')}
          </Button>
          
          <Button
            component={Link}
            to="/schedule"
            color="inherit"
            size={isMobile ? 'small' : 'medium'}
            sx={{ 
              fontWeight: isActive('/schedule') ? 600 : 400,
              color: isActive('/schedule') ? 'primary.main' : 'inherit'
            }}
          >
            {t('nav.schedule')}
          </Button>

          <IconButton
            onClick={toggleLanguage}
            size="small"
            sx={{ 
              backgroundColor: 'primary.main',
              color: 'white',
              width: 32,
              height: 32,
              fontSize: '0.75rem',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'primary.dark',
              }
            }}
          >
            {language === 'de' ? 'EN' : 'DE'}
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header; 